import { render, staticRenderFns } from "./assignDataAuth.vue?vue&type=template&id=6f7cfcd1&scoped=true"
import script from "./assignDataAuth.vue?vue&type=script&lang=js"
export * from "./assignDataAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7cfcd1",
  null
  
)

export default component.exports